import { $host } from ".";

class MegaShopApi {
  async getEvrimaData(signal) {
    const { data } = await $host.get("/evrima/shop/items", {
      signal,
    });
    return data;
  }
}

const megaShopApi = new MegaShopApi();
export default megaShopApi;
